import { render, staticRenderFns } from "./RootTabelloneCronologiaView.vue?vue&type=template&id=10bf3702&"
import script from "./RootTabelloneCronologiaView.vue?vue&type=script&lang=ts&"
export * from "./RootTabelloneCronologiaView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports